/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsMagnifyingGlassTopFromBracket: {
  name: 'magnifying-glass-top-from-bracket';
  data: string;
} = {
  name: 'magnifying-glass-top-from-bracket',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M11 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6ZM6 8a5 5 0 1 1 9.172 2.757l1.535 1.536a1 1 0 0 1-1.414 1.414l-1.536-1.535A5 5 0 0 1 6 8Zm0 10a1 1 0 1 0-2 0v1a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-1a1 1 0 1 0-2 0v1H6v-1Z" fill="currentColor"/></svg>`,
};
